const { activityTypes, ACTIVITY_METADATA_MAX_BYTES, isActivityType } = require('./activities');

module.exports = {
  activityTypes,
  ACTIVITY_METADATA_MAX_BYTES,
  isActivityType,
}
